module.exports = __webpack_public_path__ + "img/map.2731f655.png";